const supportsCustomElements = 'customElements' in window;
const supportsShadowDom = 'attachShadow' in document.documentElement;

export default supportsCustomElements && supportsShadowDom;
